export function hasChrome() {
  return (
    window.chrome &&
    window.chrome.runtime &&
    /Chrome/.test(window.navigator.userAgent)
  );
}
